import * as Yup from 'yup';
import type { FormField } from './types';

export function buildValidationSchema(fields: FormField[]) {
  const shape: Record<string, Yup.AnySchema> = {};

  for (const f of fields) {
    let s: Yup.AnySchema;

    switch (f.type) {
      case 'number':
        s = Yup.number()
          .nullable()
          .transform((v, orig) => (orig === '' ? null : v));
        break;
      case 'checkbox':
        s = Yup.boolean();
        break;
      default:
        s = Yup.string().nullable();
        break;
    }

    if (f.required && !f.disabled) {
      if (f.type === 'checkbox') {
        s = (s as Yup.BooleanSchema).oneOf([true], `${f.label} is required`);
      } else {
        s = s.required(`${f.label} is required`);
      }
    }

    shape[f.name] = s;
  }

  return Yup.object().shape(shape);
}
